"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.animateElementHeight = exports.AnimationDuration = void 0;
exports.componentWithChildren = componentWithChildren;
exports.combineParams = combineParams;
exports.getTime = getTime;
exports.cloneObject = cloneObject;
exports.getQueryParams = getQueryParams;
const animejs_1 = require("animejs");
var AnimationDuration;
(function (AnimationDuration) {
    AnimationDuration[AnimationDuration["Slow"] = 600] = "Slow";
    AnimationDuration[AnimationDuration["Fast"] = 300] = "Fast";
    AnimationDuration[AnimationDuration["SuperFast"] = 200] = "SuperFast";
})(AnimationDuration || (exports.AnimationDuration = AnimationDuration = {}));
const animateElementHeight = (animatedElement, heightValue, animationDuration, onComplete) => {
    if (animatedElement) {
        return (0, animejs_1.default)({
            targets: animatedElement,
            height: heightValue,
            easing: 'linear',
            duration: animationDuration,
            complete: onComplete,
        });
    }
    return null;
};
exports.animateElementHeight = animateElementHeight;
function componentWithChildren(Component) {
    return Component;
}
function combineParams(op) {
    /*jshint unused:true */
    if (typeof op !== 'object') {
        return '';
    }
    op.params = op.params || {};
    let combined = '', i = 0;
    const keys = Object.keys(op.params);
    if (keys.length === 0) {
        return '';
    }
    // always have parameters in the same order
    keys.sort();
    if (!op.hasParams) {
        combined += '?' + keys[0] + '=' + op.params[keys[0]];
        i += 1;
    }
    for (; i < keys.length; i += 1) {
        combined += '&' + keys[i] + '=' + op.params[keys[i]];
    }
    return combined;
}
function getTime(timeString) {
    /*jshint unused:true */
    let totalSeconds = 0;
    const timeValues = {
        s: 1,
        m: 1 * 60,
        h: 1 * 60 * 60,
        d: 1 * 60 * 60 * 24,
        w: 1 * 60 * 60 * 24 * 7,
    };
    // is the format 1h30m20s etc
    if (!timeString.match(/^(\d+[smhdw]?)+$/)) {
        return 0;
    }
    // expand to "1 h 30 m 20 s" and split
    timeString = timeString.replace(/([smhdw])/g, ' $1 ').trim();
    const timePairs = timeString.split(' ');
    for (let i = 0; i < timePairs.length; i += 2) {
        totalSeconds +=
            parseInt(timePairs[i], 10) * timeValues[timePairs[i + 1] || 's'];
    }
    return totalSeconds;
}
function cloneObject(obj) {
    /*jshint unused:true */
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    const temp = obj.constructor(); // give temp the original obj's constructor
    for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key)) {
            temp[key] = cloneObject(obj[key]);
        }
    }
    return temp;
}
function getQueryParams(qs) {
    /*jshint unused:true */
    if (typeof qs !== 'string') {
        return {};
    }
    qs = qs.split('+').join(' ');
    const params = {};
    const match = qs.match(
    /*jshint ignore:start */
    /(?:[\?](?:[^=]+)=(?:[^&#]*)(?:[&](?:[^=]+)=(?:[^&#]*))*(?:[#].*)?)|(?:[#].*)/);
    if (match === null) {
        return {};
    }
    const split = match[0].substr(1).split(/[&#=]/);
    for (let i = 0; i < split.length; i += 2) {
        params[decodeURIComponent(split[i])] = decodeURIComponent(split[i + 1] || '');
    }
    return params;
}
